'use-strict';
import React, { Component } from 'react';
import './contact-us.css';
import $ from 'jquery';
import { ToastContainer } from 'react-toastify';
import toast from '../toast';
import { css } from 'glamor';

class ContactUs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            subject: '',
            message: ''
        };
    }
    handleSubmit = (event) => {
        event.preventDefault();
        let object = {
            name: this.state.name,
            email: this.state.email,
            subject: this.state.subject,
            message: this.state.message
        }
        $.ajax({
            url: "/api/v1/contact-us",
            method: 'POST',
            data: JSON.stringify(object),
            success: function (resp) {
                console.log(resp.message)
                toast.success(resp.message);
                // this.setState({ startLoader: !this.state.startLoader })
            }.bind(this),
            error: function (errorData) {
                console.log('error->', errorData)
            }.bind(this)
        })
    }

    render() {
        return (
            // <div className="container contact-form">
            //     <div className="content">
            //         <div className="contactForm">
            //             <form id="contact-form" onSubmit={this.handleSubmit}>
            //                 <div className="row contact-text"><h2>Contact Us</h2></div>
            //                 <div className="row formRow mt-4">
            //                     <div className="col-6">
            //                         <input type="text" name="Nome" className="form-control formInput" placeholder="Nome" onChange={(e) => this.setState({ name: e.target.value })} required />
            //                     </div>
            //                     <div className="col-6">
            //                         <input type="email" name="E-mail" className="form-control formInput" placeholder="Endereço de email" onChange={(e) => this.setState({ email: e.target.value })} required />
            //                     </div>
            //                 </div>
            //                 <div className="row formRow"><div className="col">
            //                     <input type="text" name="subject" className="form-control formInput" placeholder="Sujeita" onChange={(e) => this.setState({ subject: e.target.value })} required />
            //                 </div>
            //                 </div>
            //                 <div className="row formRow"><div className="col"><textarea rows="3" name="message" className="form-control formInput" onChange={(e) => this.setState({ message: e.target.value })} placeholder="Mensagem" required>
            //                 </textarea></div>
            //                 </div>
            //                 <div className="row contact-text"><button className="submit-btn" type="submit">Submit</button></div>
            //                 <br />
            //                 <br />

            //             </form>
            //            
            //     </div>
            // </div>

            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12 contact-form">
                    <div class="wrapper">
                        <div class="row no-gutters">
                            <div class="col-md-7 d-flex align-items-stretch">
                                <div class="contact-wrap w-100 p-md-5 p-4">
                                    <h2 class="mb-4">Entrar em contato</h2>
                                    <form id="contactForm" name="contactForm" onSubmit={this.handleSubmit}>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" name="name" id="name" placeholder="Nome" onChange={(e) => this.setState({ name: e.target.value })} required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input type="email" class="form-control" name="email" id="email" placeholder="Endereço de email" onChange={(e) => this.setState({ email: e.target.value })} required />
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" name="subject" id="subject" placeholder="Sujeita" onChange={(e) => this.setState({ subject: e.target.value })} required />
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <textarea name="message" class="form-control" id="message" cols="30" rows="7" placeholder="Mensagem" onChange={(e) => this.setState({ message: e.target.value })} required></textarea>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <input type="submit" value="Send Message" class="btn contact-box text-white" />
                                                    <div class="submitting"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="col-md-5 d-flex align-items-stretch">
                                <div class="info-wrap contact-box w-100 p-lg-5 p-4">
                                    <h2 class="mb-4 mt-md-4 text-white">Contate-Nos</h2>
                                    <div class="dbox w-100 d-flex align-items-start">
                                        <div class="icon d-flex align-items-center justify-content-center">
                                            <span class="fa fa-map-marker"></span>
                                        </div>
                                        <div class="text pl-3">
                                            <p><span>Address:</span> <span className='text-white'>Rua Espirito Santo, 54, Rosa dos Ventos - Parnamirim, RN
                                                CEP: 59141255 - Brazil</span></p>
                                        </div>
                                    </div>
                                    <div class="dbox w-100 d-flex align-items-center">
                                        <div class="icon d-flex align-items-center justify-content-center">
                                            <span class="fa fa-phone"></span>
                                        </div>
                                        <div class="text pl-3">
                                            <p><span>Phone:</span> <a className='text-white' href="tel://1234567920">+55 8420206153</a></p>
                                        </div>
                                    </div>
                                    <div class="dbox w-100 d-flex align-items-center">
                                        <div class="icon d-flex align-items-center justify-content-center">
                                            <span class="fa fa-paper-plane"></span>
                                        </div>
                                        <div class="text pl-3">
                                            <p><span>Email:</span> <a className='text-white' href="mailto:info@yoursite.com">vendas@relaystream.io</a></p>
                                        </div>
                                    </div>
                                    <div class="dbox w-100 d-flex align-items-center">
                                        <div class="icon d-flex align-items-center justify-content-center">
                                            <span class="fa fa-globe"></span>
                                        </div>
                                        <div class="text pl-3">
                                            <p><span>Website</span> <a className='text-white' href="#">https://app.relaystream.io</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <span className='notification-text'> Nota: Se você estiver enfrentando algum problema para usar com seu aplicativo, poderá enviar qualquer consulta conosco a qualquer momento.</span>

                    </div>
                </div>
                <ToastContainer
                    className={{ textAlign: 'center' }}
                    progressClassName={css({ background: '#00B39F' })} />
            </div >
        )
    }
}
export default ContactUs;


// WEBPACK FOOTER //
// ./src/components/ContactUs/contact-us.js